module.exports = __webpack_public_path__ + "static/img/Testimonial.a9b8acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonial.png
// module id = bGw/
// module chunks = 36